import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import DailyLogReportReportCriteria from './DailyLogReportReportCriteria';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';

@NeoReport("DailyLogReport",  { category: MaintenanceReportCategories.SystemInformationReports})
export default class DailyLogReportReport extends Report<DailyLogReportReportCriteria>{

    constructor() {
        super(DailyLogReportReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
            <Neo.FormGroup label={TextConstants.Labels.StartDate} bind={this.criteria.meta.Criteria} dateProps={{ formatString: "dd MMM yyyy HH:mm" }} />
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}